const BRANDED_TYPE_BY_STYLE = {
  "heading": "BrandedHeadingElement",
  "subheading": "BrandedSubHeadingElement",
  "title": "BrandedTitleElement",
  "label": "BrandedLabelElement",
  "paragraph": "BrandedParagraphElement",
  "note": "BrandedNoteElement",
};

const TYPOGRAPHY_LABEL_BY_TYPE = {
  BrandedHeadingElement: "Heading",
  BrandedSubHeadingElement: "Sub Heading",
  BrandedTitleElement: "Title",
  BrandedLabelElement: "Label",
  BrandedParagraphElement: "Paragraph",
  BrandedNoteElement: "Note",
};

const TYPOGRAPHY_STYLE_LABELS = new Set(Object.values(TYPOGRAPHY_LABEL_BY_TYPE));

module.exports = {
  BRANDED_TYPE_BY_STYLE,
  TYPOGRAPHY_LABEL_BY_TYPE,
  TYPOGRAPHY_STYLE_LABELS,
};
